import Fingerprint from '@mui/icons-material/Fingerprint'
import { Alert, AlertTitle, Button, Stack, type SxProps, type Theme } from '@mui/material'
import { useEffect, useState } from 'preact/hooks'
import type { Passkey } from '../api/generated/Passkey'
import { useAction } from '../api/useAction'
import { usePromptTurn } from '../promptTurn'
import {
  createPasskey,
  isAlreadyRegistered,
  isCancelled,
  markOfferDone,
  shouldOfferPasskey,
} from './passkey'

/** Offers to create a passkey on this device, until one is created or the user declines. */
export function PasskeyOffer({
  onCreated,
  sx = { mb: 3 },
}: {
  onCreated?: (passkeys: Passkey[]) => void
  sx?: SxProps<Theme>
}) {
  const [visible, setVisible] = useState(false)
  const { error, pending, run } = useAction()

  useEffect(() => {
    shouldOfferPasskey().then(setVisible, () => {})
  }, [])
  const turn = usePromptTurn('passkey', visible)

  if (!turn) return null

  const close = () => {
    markOfferDone()
    setVisible(false)
  }

  const create = () =>
    run(async () => {
      try {
        onCreated?.(await createPasskey())
      } catch (e) {
        if (isCancelled(e)) return
        if (!isAlreadyRegistered(e)) throw e
      }
      close()
    })

  return (
    <Alert severity="info" icon={<Fingerprint />} sx={sx}>
      <AlertTitle>Connexion plus rapide</AlertTitle>
      Créez une clé d'accès : la prochaine fois, Face ID, votre empreinte ou le code de cet appareil
      suffiront pour vous connecter.
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Button variant="contained" size="small" loading={pending} onClick={create}>
          Créer une clé d'accès
        </Button>
        <Button size="small" onClick={close}>
          Plus tard
        </Button>
      </Stack>
    </Alert>
  )
}
